import { useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import { useTranslation } from "react-i18next";
import { useSurveySavedNotification, useUpdateSurvey } from "@pulse/features/Edit/hooks";
import { useEditSurveyForm } from "../formHooks";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";
import { validateSurveyFields } from "./titleValidation";

export function TitleEdit() {
    const { data } = useCurrentSurvey();
    const { t } = useTranslation();
    const surveySavedNotification = useSurveySavedNotification();
    const surveyMutation = useUpdateSurvey(data.id);
    const form = useEditSurveyForm({
        defaultValues: {
            title: data.title,
            description: data.description,
        },
        listeners: {
            onBlur: ({ formApi }) => formApi.handleSubmit(),
        },
        validators: {
            onChange: ({ value }) => validateSurveyFields(value, t),
        },
        onSubmit: async ({ value, formApi }) => {
            if (formApi.state.isDefaultValue) {
                return;
            }
            const promise = surveyMutation.mutateAsync(value);
            surveySavedNotification(promise);
        },
    });
    const anonymityText = `This survey is completely anonymous.

We do not collect names, email addresses, IP addresses, or any other information that can identify respondents. It is therefore not technically possible to see who has completed the survey or who gave a particular answer.

Results will only be reviewed in aggregated form.`;
    return (
        <div className="flex flex-col gap-5">
            <form.AppField name="title">
                {(field) => (
                    <field.Input
                        autoFocus
                        maxCharacters={PULSE_FIELD_LIMITS.survey.title}
                        className="text-h1 font-medium"
                    />
                )}
            </form.AppField>
            <form.AppField name="description">
                {(field) => (
                    <div className="flex flex-col gap-3">
                        <field.TextArea
                            placeholder={t("survey.descriptionPlaceholder")}
                            maxCharacters={PULSE_FIELD_LIMITS.survey.description}
                            className="min-h-24 px-3 py-2 text-base font-light"
                        />
                        <p className="text-sm text-on-background/70 whitespace-pre-wrap">
                            {anonymityText}
                        </p>
                    </div>
                )}
            </form.AppField>
        </div>
    );
}
